import { NonWorkingDay } from '../renderer/nonworking-day';
import { EventMarker } from '../renderer/event-marker';
import { getValue } from '@syncfusion/ej2-base';
/**
 * DayMarkers module is used to render event markers, holidays and to highlight the weekend days.
 */
export class DayMarkers {
    constructor(parent) {
        this.parent = parent;
        this.nonworkingDayRender = new NonWorkingDay(this.parent);
        this.eventMarkerRender = new EventMarker(this.parent);
        this.wireEvents();
    }
    wireEvents() {
        this.parent.on('refreshDayMarkers', this.refreshMarkers, this);
        this.parent.on('updateHeight', this.updateHeight, this);
        this.parent.on('ui-update', this.propertyChanged, this);
    }
    propertyChanged(property) {
        const keys = Object.keys(getValue('properties', property));
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            switch (key) {
                case 'eventMarkers':
                    this.eventMarkerRender.renderEventMarkers();
                    this.updateHeight();
                    break;
                case 'highlightWeekends':
                    this.nonworkingDayRender.renderWeekends();
                    this.updateHeight();
                    break;
                case 'holidays':
                    this.nonworkingDayRender.renderHolidays();
                    this.updateHeight();
                    break;
            }
        }
    }
    refreshMarkers() {
        this.nonworkingDayRender.renderWeekends();
        this.nonworkingDayRender.renderHolidays();
        if (this.parent.gridLines === 'Vertical' || this.parent.gridLines === 'Both') {
            this.parent['renderChartVerticalLines']();
        }
        this.eventMarkerRender.renderEventMarkers();
    }
    updateHeight() {
        this.nonworkingDayRender.updateContainerHeight();
        this.eventMarkerRender.updateContainerHeight();
        this.parent.ganttChartModule.scrollObject.updateTopPosition();
    }
    /**
     * To get module name
     *
     * @returns {string} .
     */
    getModuleName() {
        return 'dayMarkers';
    }
    /**
     * @returns {void} .
     * @private
     */
    destroy() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.nonworkingDayRender.removeContainers();
        this.eventMarkerRender.removeContainer();
        this.parent.off('refreshDayMarkers', this.refreshMarkers);
        this.parent.off('updateHeight', this.updateHeight);
        this.parent.off('ui-update', this.propertyChanged);
    }
}
